import { BrowserRouter, Route, Routes } from "react-router-dom";
import  ProtectedRoute from './ProtectedRoute';
import Dashboard from './components/Dashboard';
import Home from "./components/Home";
import Register2 from "./components/Register2";
import Header from "./components/Header";
import Login from "./components/Login";
import { useState,useEffect } from "react";
export default function App() {
  const specificUnixTime = 1696294800; // Replace with your specific UNIX time
  const [isTimeExpired, setIsTimeExpired] = useState(false);

  useEffect(() => {
    const intervalId = setInterval(() => {
      const currentTime = Math.floor(Date.now() / 1000); // Get current UNIX time in seconds

      if (currentTime > specificUnixTime) {
        setIsTimeExpired(true);
        clearInterval(intervalId); // Stop checking once the time has expired
      } else {
        setIsTimeExpired(false);
      }
    }, 1000); // Check every second

    return () => {
      clearInterval(intervalId); // Clean up the interval when the component unmounts
    };
  }, []);
  return (
    <div className="App">
      <Header/>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />}></Route>
          {/* <Route path="/" element={<TreasureHunt/>}></Route> */}
          {!isTimeExpired && <Route path="/codeSpark" element={<Register2/>}></Route>}
          <Route path='/admin' element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path='/login' element={<Login/>} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}
